module.exports = __webpack_public_path__ + "assets/img/media_15.302e327d.png";